module.exports = __webpack_public_path__ + "static/1265315806-wide.51786b50.jpg";